import injectStores from '../RootStore/injectStores';

import React, { CSSProperties, ReactNode } from 'react';

interface FlexRowProps {
  style?: CSSProperties;
  children?: ReactNode;
  onClick?: () => void;
}

class FlexRow extends React.PureComponent<FlexRowProps> {
  render() {
    const { children, style, onClick, ...rest } = this.props;
    return (
      <div
        style={{ display: 'flex', flexDirection: 'row', ...style }}
        onClick={onClick}
        {...rest}
      >
        {children}
      </div>
    );
  }
}

export default injectStores(FlexRow);
